var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C9.66 2 11 3.34 11 5C11 5.14177 10.99 5.27977 10.9707 5.41445C10.9291 5.7065 11.205 6 11.5 6C12.88 6 14 7.12 14 8.5C14 9.58512 13.3075 10.5095 12.3406 10.855C11.8949 11.0143 11.5 11.3838 11.5 11.8571C11.5 12.4883 12.0199 13.0148 12.6308 12.8559C14.5658 12.3527 16 10.5897 16 8.5C16 6.52 14.72 4.84 12.94 4.24C12.57 1.84 10.5 0 8 0C5.5 0 3.43 1.84 3.06 4.24C1.28 4.84 0 6.52 0 8.5C0 10.5897 1.43415 12.3527 3.36922 12.8559C3.98008 13.0148 4.5 12.4883 4.5 11.8571C4.5 11.3838 4.10514 11.0143 3.65936 10.855C2.69249 10.5095 2 9.58512 2 8.5C2 7.12 3.12 6 4.5 6C4.795 6 5.07091 5.7065 5.02926 5.41445C5.01005 5.27977 5 5.14177 5 5C5 3.34 6.34 2 8 2ZM7.00269 7L7.00269 12.5882L6.58716 12.1728C6.19663 11.7824 5.56347 11.7824 5.17294 12.1728C4.78242 12.5632 4.78242 13.1962 5.17294 13.5866L7.29217 15.7051L7.29425 15.7072L7.29427 15.7072C7.34308 15.756 7.39569 15.7987 7.45114 15.8353L7.65264 15.9375C8.00787 16.0694 8.423 15.9926 8.70848 15.7072L8.71201 15.7037L10.8298 13.5866C11.2203 13.1962 11.2203 12.5632 10.8298 12.1728C10.4393 11.7824 9.8061 11.7824 9.41558 12.1728L9.00269 12.5855L9.00269 7C9.00269 6.44772 8.55497 6 8.00269 6C7.4504 6 7.00269 6.44771 7.00269 7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.82641b2ffbc2f2e6b7a1e0b950970075.svg";
export { ForwardRef as ReactComponent };